import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4120dc38"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "add-account"
};
import { ref } from 'vue';
import addPayTenantDialog from './components/addPayTenantDialog.vue';
import router from '@/router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useDebounceFn } from '@vueuse/shared';
import { delPayment, getPaymentPage } from '@/api/payment';
export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);
    const currentPage = ref(1);
    const total = ref(0);
    const pageSize = ref(8);
    const activeName = ref('p1');
    const tabArr = [{
      label: '华夏银行',
      value: 'p1'
    }, {
      label: '兴业银行',
      value: 'p2'
    }];
    const handleChange = useDebounceFn(async () => {
      tableData.value = [];
      loading.value = true;
      try {
        await getPayTenantData();
      } catch (error) {} finally {
        loading.value = false;
      }
    });

    /**
     * 获取广告组分页
     */
    const getPayTenantData = async () => {
      const res = await getPaymentPage({
        currentPage: currentPage.value,
        pageSize: 10,
        platform: activeName.value
      });

      // console.log(res)

      tableData.value = res.records;
      total.value = res.total;
      currentPage.value = res.current;
    };
    getPayTenantData();

    // loading效果
    const loading = ref(false);

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = async val => {
      currentPage.value = val;
      await getPayTenantData();
    };

    /** 新增飞书应用 */
    const addPayTenantVisible = ref(false);
    const onAddPayTenantHandler = () => {
      addPayTenantVisible.value = true;
    };

    /** 跳转飞书租户信息页面 */
    const handleToPayTenantMessage = row => {
      router.push(`/operation/paymentManage/paymentManInfo/${row.id}`);
    };
    const currentTenant = ref(null);
    const handleUpdatePayTenant = row => {
      currentTenant.value = row;
      onAddPayTenantHandler();
    };
    const clearCurrentTenantData = () => {
      // console.log('clearCurrentTenantData')
      currentTenant.value = null;
      // console.log(currentTenant.value, 'currentTenant.value')
    };
    const handleDelPayTenant = row => {
      ElMessageBox.confirm('是否删除该租户', '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await delPayment(row.id);
        await getPayTenantData();
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: onAddPayTenantHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['paymentAdd']]])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
          type: "card",
          class: "demo-tabs",
          onTabChange: _unref(handleChange)
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabArr, (item, index) => {
            return _createVNode(_component_el_tab_pane, {
              label: item.label,
              name: item.value,
              key: index
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: tableData.value,
                style: {
                  "width": "100%"
                },
                border: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "应用名称"
                }), _createVNode(_component_el_table_column, {
                  prop: "id",
                  label: "租户id"
                }), activeName.value === 'p2' ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: "appId",
                  label: "应用id"
                })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
                  prop: "keyId",
                  label: activeName.value === 'p1' ? '服务商编号' : '机构号'
                }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
                  prop: "mchId",
                  label: activeName.value === 'p1' ? '商户id(由平台分配)' : '商户号'
                }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
                  prop: "createTime",
                  label: "创建时间"
                }), _createVNode(_component_el_table_column, {
                  prop: "statusName",
                  label: "状态",
                  "min-width": "40"
                }), _createVNode(_component_el_table_column, {
                  label: "操作",
                  "min-width": "120"
                }, {
                  default: _withCtx(({
                    row
                  }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    type: "success",
                    size: "small",
                    onClick: $event => handleToPayTenantMessage(row)
                  }, {
                    default: _withCtx(() => [_createTextVNode(" 查看 ")]),
                    _: 2
                  }, 1032, ["onClick"])), [[_directive_permission, ['paymentInfo']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: $event => handleUpdatePayTenant(row)
                  }, {
                    default: _withCtx(() => [_createTextVNode(" 修改 ")]),
                    _: 2
                  }, 1032, ["onClick"])), [[_directive_permission, ['paymentUpdate']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    type: "danger",
                    size: "small",
                    onClick: $event => handleDelPayTenant(row)
                  }, {
                    default: _withCtx(() => [_createTextVNode(" 删除 ")]),
                    _: 2
                  }, 1032, ["onClick"])), [[_directive_permission, ['paymentDelete']]])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data"])), [[_directive_loading, loading.value]])]),
              _: 2
            }, 1032, ["label", "name"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue", "onTabChange"]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          "current-page": currentPage.value,
          "page-size": pageSize.value,
          total: total.value,
          layout: "total,  prev, pager, next, jumper",
          style: {
            "margin-top": "10px"
          }
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(addPayTenantDialog, {
        modelValue: addPayTenantVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => addPayTenantVisible.value = $event),
        model: currentTenant.value,
        onRefreshData: getPayTenantData,
        onClearModel: clearCurrentTenantData,
        title: `新增${activeName.value === '1' ? '自建应用' : '商业应用租户'}`
      }, null, 8, ["modelValue", "model", "title"])]);
    };
  }
};